import type { ChartSpec } from '../chartUtils';

export default function ChartError({ message, spec }: { message: string; spec: ChartSpec }) {
  const firstRow = spec.data[0] || {};
  return (
    <div className="mt-3 p-4 rounded-lg border border-orange-500/30 bg-orange-950/20">
      <div className="text-sm text-orange-300/80">{message}</div>
      <div className="text-xs text-muted-foreground/60 mt-1">
        {spec.data.length} rows, keys: [{Object.keys(firstRow).join(', ')}]
      </div>
    </div>
  );
}
